<div class="widthClass">
  <mat-toolbar mat-dialog-title class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">&nbsp;Case Hearing on {{data.date | date: 'mediumDate'}}</span>
      <button (click)="dialogRef.close(false)" aria-label="Close dialog">
        <mat-icon class="closebtn">close</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <mat-progress-bar *ngIf="loading" mode="query" class="my-color" mode="query" value="value" [bufferValue]="bufferValue">
  </mat-progress-bar>

  <div style="margin:30px;">
    <div class="actionButtons" *ngIf="showTable">
      <button mat-raised-button color="accent" [class.loading]="loading" aria-label="Download" (click)="downloadAllCaseForms()" [disabled]="loading">
        <div class="spinner"></div>
        <span class="label" style="text-transform: uppercase;">Download 2.3</span>
      </button>

      <button mat-raised-button color="accent" aria-label="Move" (click)="moveCase()" [disabled]="removeBtn">
        <div class="spinner"></div>
        <span class="label" style="text-transform: uppercase;">Move</span>
      </button>
    </div>

    <br>

    <div *ngIf="showTable" class="mat-elevation-z8">
      <mat-table #table [dataSource]="tableData">
        <ng-container matColumnDef="case_number">
          <mat-header-cell *matHeaderCellDef> Case Number </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <button mat-button color="accent" (click)="openCase(element)">
              {{element.summary?.case_number ? element.summary?.case_number : 'open' }}
            </button>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="ward">
          <mat-header-cell *matHeaderCellDef> Ward </mat-header-cell>
          <mat-cell *matCellDef="let element">
              {{ element.ward?.name }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="created_date">
          <mat-header-cell *matHeaderCellDef> Petition Filed </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.summary?.created_date | date}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="modified_date">
          <mat-header-cell *matHeaderCellDef> Last Updated </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.summary?.modified_date | date}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef> Type </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{element.summary?.type}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="move">
          <mat-header-cell *matHeaderCellDef> Move </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-checkbox (change)="selectedCase($event.checked, element.id)"></mat-checkbox>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
      <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons>
      </mat-paginator>
    </div>

    <div *ngIf="!showTable && !loading" align="center">
      <b>No cases found</b>
    </div>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/content/court-dates/docket-case/docket-case.component.html